import { createAction, createSlice } from '@reduxjs/toolkit';
import initState from '../../../domain/entities/paises';

function validarPaises(state, action) {
  const { responsePaises } = action.payload;
  state.response = responsePaises;
  state.responseError = false;
}


function validarPaisesError(state) {
  state.response = [];
  state.responseError = true;
}


const paisesServicio = createAction('paisesServicio');


const paisesReducer = createSlice({
  name: 'paises',
  initialState: initState,
  reducers: {
    validarPaises,
    validarPaisesError,
  },
});

export const paisesActions = {
  ...paisesReducer.actions,
  paisesServicio,
};

export default paisesReducer.reducer;
